import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../assets/css/style.css";

import bannerImage from "../assets/img/ban1.jpg";
import dummyimage from "../assets/img/dummyimage.png";
import userimg from "../assets/img/userimg.png";

const ITEMS_PER_PAGE = 15; // Display 15 items per page

// Mock data for fallbacks
const MOCK_COMPANY_NAMES = [
  { company_id: 1, company_name: "Acme Corp" },
  { company_id: 2, company_name: "Globex Inc" },
  { company_id: 3, company_name: "Initech" },
];
const MOCK_INDUSTRIES = ["Technology", "Healthcare", "Finance"];

// Reusable Pagination Component
const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const pageGroup = Math.ceil(currentPage / 3);
  const startPage = (pageGroup - 1) * 3 + 1;
  const endPage = Math.min(startPage + 2, totalPages);
  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  return (
    <nav aria-label="Page navigation" className="mt-5">
      <ul className="pagination justify-content-center">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link fw-400"
            onClick={() => handlePageChange(currentPage - 1)}
          >
           <i class='fas fa-arrow-left px-2'></i> Prev
          </button>
        </li>
        {pageNumbers.map((page) => (
          <li
            key={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link fw-400"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next <i class='fas fa-arrow-right px-2'></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default function FilterTable() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Company");
  const [companies, setCompanies] = useState([]);
  const [people, setPeople] = useState([]);

  const [searchTermglobal, setSearchTermglobal] = useState("");   //Add Ravi

  const [filters, setFilters] = useState({
    search: "",
    companyName: "",
    employees: "",
    revenue: "",
    industry: "",
    job_title: "",
    location: "",
  });

  const [companyNameList, setCompanyNameList] = useState([]);
  const [filteredCompanyNames, setFilteredCompanyNames] = useState([]);
  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const [companySearchTerm, setCompanySearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);
  const [isEmployeeDropdownOpen, setIsEmployeeDropdownOpen] = useState(false);
  const [employeeSearchTerm, setEmployeeSearchTerm] = useState("");
  const [revenueList, setRevenueList] = useState([]);
  const [filteredRevenueList, setFilteredRevenueList] = useState([]);
  const [isRevenueDropdownOpen, setIsRevenueDropdownOpen] = useState(false);
  const [revenueSearchTerm, setRevenueSearchTerm] = useState("");
  const [industryList, setIndustryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const companyDropdownRef = useRef(null);
  const employeeDropdownRef = useRef(null);
  const revenueDropdownRef = useRef(null);

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { state: { errorMessage: "Please log in to access this page." } });
    }
  }, [navigate]);

  
  useEffect(() => {
    fetchData();
  }, [filters, activeTab, currentPage]);


  // useEffect(() => {
  //   fetchData();
  // }, [activeTab]);




  const searchStart = () => {
    fetchData();
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      const endpoint = `${process.env.REACT_APP_API_URL}/api/company/data?page=${currentPage}`;
      console.log("Fetching data from:", endpoint, "with filters:", {
        ...filters,
        company_name: filters.companyName,
        primary_industry: filters.industry || "",
      });
      const response = await axios.post(
        endpoint,
        {
          ...filters,
          company_name: filters.companyName || "",
          primary_industry: filters.industry || "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Company data response:", response.data);

      if (activeTab === "Company") {
        const formattedCompanies =
          response.data?.companyDetails?.result?.map((company) => {
            const answerMap = {};
            (company.answers || []).forEach((a) => {
              if (answerMap[a.question_id]) {
                answerMap[a.question_id].push(a.answer);
              } else {
                answerMap[a.question_id] = [a.answer];
              }
            });

            const cityAnswers = answerMap[40] || [];
            const city =
              cityAnswers.length >= 5 && cityAnswers[1] && cityAnswers[4]
                ? `${cityAnswers[1]}`
                : "NA";

            return {
              company_id: company.company_id,
              company_img: answerMap[38]?.join(", ") || "",
              company_name: answerMap[32]?.join(", ") || company.company_name || "",
              company_url: answerMap[34]?.join(", ") || company.company_url || "",
              founded: answerMap[41]?.join(", ") || "",
              city: city,
              state: "",
              primary_industry: answerMap[43]?.join(", ") || "",
              employees: answerMap[42]?.join(", ") || "",
            };
          }) || [];
        setCompanies(formattedCompanies);
        const companyTotal = response.data?.companyCount?.[0]?.companyTotal || 0;
        setTotalPages(Math.ceil(companyTotal / ITEMS_PER_PAGE));
      } else {
        setPeople(
          Array.isArray(response.data?.userDetails?.data)
            ? response.data.userDetails.data
            : response.data?.userDetails || []
        );
        const userTotal = response.data?.userCount?.[0]?.usertotal || 0;
        setTotalPages(Math.ceil(userTotal / ITEMS_PER_PAGE));
      }
    } catch (error) {
      console.error("API error for /api/company/data:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      if (error.response?.status === 401) {
        setError("Session expired. Please log in again.");
        localStorage.removeItem("token");
        navigate("/login", { state: { errorMessage: "Session expired. Please log in again." } });
      } else {
        setError(`Failed to fetch data: ${error.response?.status || "Unknown"} - ${error.response?.data?.message || error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyNames();
    fetchEmployeeData();
    fetchRevenueData();
    fetchIndustries();
  }, []);

  const fetchCompanyNames = async () => {
    try {
      const token = localStorage.getItem("token");
      const endpoint = `${process.env.REACT_APP_API_URL}/api/company_name`;
      console.log("Fetching company names from:", endpoint);
      const response = await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Company names response:", response.data);

      if (response.data?.company_name) {
        const validCompanies = response.data.company_name.filter(
          (company) => company && company.company_name
        );
        setCompanyNameList(validCompanies);
        setFilteredCompanyNames(validCompanies);
      } else {
        console.warn("No company names in response, using mock data");
        setCompanyNameList(MOCK_COMPANY_NAMES);
        setFilteredCompanyNames(MOCK_COMPANY_NAMES);
        setError("No company names available. Using sample data.");
      }
    } catch (error) {
      console.error("API error for /api/company_name:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      setCompanyNameList(MOCK_COMPANY_NAMES);
      setFilteredCompanyNames(MOCK_COMPANY_NAMES);
      setError(`Failed to fetch company names: ${error.response?.status || "Unknown"} - ${error.response?.data?.message || error.message}. Using sample data.`);
    }
  };

  const fetchEmployeeData = async () => {
    try {
      const token = localStorage.getItem("token");
      const endpoint = `${process.env.REACT_APP_API_URL}/api/employee`;
      console.log("Fetching employee data from:", endpoint);
      const response = await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Employee data response:", response.data);

      if (response.data?.employees?.length) {
        const employees = response.data.employees.map((emp) => emp.answer.trim());
        setEmployeeList(employees);
        setFilteredEmployeeList(employees);
      } else {
        setEmployeeList([]);
        setFilteredEmployeeList([]);
      }
    } catch (error) {
      console.error("API error for /api/employee:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      setError(`Failed to fetch employee data: ${error.response?.status || "Unknown"} - ${error.response?.data?.message || error.message}`);
    }
  };

  const fetchRevenueData = async () => {
    try {
      const token = localStorage.getItem("token");
      const endpoint = `${process.env.REACT_APP_API_URL}/api/revenue`;
      console.log("Fetching revenue data from:", endpoint);
      const response = await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Revenue data response:", response.data);

      if (response.data?.revenue?.length) {
        const revenues = response.data.revenue.map((r) => r.answer.trim());
        setRevenueList(revenues);
        setFilteredRevenueList(revenues);
      } else {
        setRevenueList([]);
        setFilteredRevenueList([]);
      }
    } catch (error) {
      console.error("API error for /api/revenue:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      setError(`Failed to fetch revenue data: ${error.response?.status || "Unknown"} - ${error.response?.data?.message || error.message}`);
    }
  };

  const fetchIndustries = async () => {
    try {
      const token = localStorage.getItem("token");
      const endpoint = `${process.env.REACT_APP_API_URL}/api/sectorIndustries`;
      console.log("Fetching industries from:", endpoint);
      const response = await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Industries response:", response.data);

      if (response.data?.result) {
        const subIndustries = response.data.result.flatMap((sector) =>
          sector.industries.flatMap((industry) => industry.sub_industries)
        );
        const uniqueSubIndustries = [...new Set(subIndustries)].sort();
        setIndustryList(uniqueSubIndustries);
      } else {
        console.warn("No industries in response, using mock data");
        setIndustryList(MOCK_INDUSTRIES);
        setError("No industries available. Using sample data.");
      }
    } catch (error) {
      console.error("API error for /api/sectorIndustries:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      setIndustryList(MOCK_INDUSTRIES);
      setError(`Failed to fetch industries: ${error.response?.status || "Unknown"} - ${error.response?.data?.message || error.message}. Using sample data.`);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setCurrentPage(1);
  };

  const handleCompanySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setCompanySearchTerm(searchTerm);
    const filtered = companyNameList.filter((company) => {
      if (
        !company ||
        !company.company_name ||
        typeof company.company_name !== "string"
      ) {
        console.warn("Invalid company data:", company);
        return false;
      }
      return company.company_name.toLowerCase().includes(searchTerm);
    });
    setFilteredCompanyNames(filtered);
  };

  const handleCompanySelect = (companyName) => {
    setFilters((prev) => ({
      ...prev,
      companyName: companyName,
    }));
    setCompanySearchTerm(companyName);
    setIsCompanyDropdownOpen(false);
    setCurrentPage(1);
  };

  const handleEmployeeSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setEmployeeSearchTerm(searchTerm);
    const filtered = employeeList.filter((employee) =>
      employee.toLowerCase().includes(searchTerm)
    );
    setFilteredEmployeeList(filtered);
  };

  const handleEmployeeSelect = (employee) => {
    setFilters((prev) => ({
      ...prev,
      employees: employee,
    }));
    setEmployeeSearchTerm(employee);
    setIsEmployeeDropdownOpen(false);
    setCurrentPage(1);
  };

  const handleRevenueSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setRevenueSearchTerm(searchTerm);
    const filtered = revenueList.filter((revenue) =>
      revenue.toLowerCase().includes(searchTerm)
    );
    setFilteredRevenueList(filtered);
  };

  const handleRevenueSelect = (revenue) => {
    setFilters((prev) => ({
      ...prev,
      revenue: revenue,
    }));
    setRevenueSearchTerm(revenue);
    setIsRevenueDropdownOpen(false);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(event.target)
      ) {
        setIsCompanyDropdownOpen(false);
      }
      if (
        employeeDropdownRef.current &&
        !employeeDropdownRef.current.contains(event.target)
      ) {
        setIsEmployeeDropdownOpen(false);
      }
      if (
        revenueDropdownRef.current &&
        !revenueDropdownRef.current.contains(event.target)
      ) {
        setIsRevenueDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div id="wrapper">
      <section
        id="banner"
        style={{
          minHeight: "480px",
          background: `url(${bannerImage}) center left no-repeat`,
          backgroundSize: "cover",
        }}
        className="d-flex py-5"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 mx-auto pt-5">
              <div className="text-center pt-5">
                <h1 className="text-white display2 mb-3 fw-700">
                  Connecting Professionals, Empowering Insights
                </h1>
                <h4 className="fw-400 text-white cbcbcb lh-26">
                  Our platform connects industry professionals, enabling meaningful networking and collaboration. Stay informed, share insights, and expand your professional circle with ease.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="inner_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xl-4">
              <aside id="asidebar_inner" className="ft-15 lh-22">
                <div className="first_box card_box">
                  <form
                    className="position-relative search_aside"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <i className="bi bi-search"></i>
                    <input
                      type="text"
                      name="search"
                      className="form-control"
                      placeholder="Search"
                      value={filters.search}
                      onChange={handleInputChange}
                    />
                    <button
                      onClick={searchStart}
                      className="btngo ft-13 fw-400 lh-16"
                      style={{
                        position: "absolute",
                        right: filters.search ? "45px" : "10px", // Slide left if input exists
                        top: "50%",
                        transform: "translateY(-50%)",
                        transition: "right 0.3s ease",
                        zIndex: 2,
                      }}
                    >
                      <i className='fas fa-arrow-right ft-16'></i>
                     
                    </button>

                    {filters.search && (
                      <button
                        className="btn ft-20"
                        style={{ position: "absolute", right: "10px", top: "50%", zIndex: "1", transform: "translateY(-50%)" }}
                        onClick={() =>
                          handleInputChange({
                            target: { name: "search", value: "" },
                          })
                        }
                      >
                         <i className='fas fa-close mx-0'></i>
                      </button>
                    )}
                  </form>
                  <div className="d-flex justify-content-between mt-3">
                    <h4 className="fw-700">Filters</h4>
                    <a
                      href="#"
                      className="color746E6E"
                      onClick={() => {
                        const clearedFilters = {
                          search: "",
                          companyName: "",
                          employees: "",
                          revenue: "",
                          industry: "",
                          job_title: "",
                          location: "",
                        };
                        setFilters(clearedFilters);
                        setCompanySearchTerm("");
                        setEmployeeSearchTerm("");
                        setRevenueSearchTerm("");
                        setFilteredCompanyNames(companyNameList);
                        setFilteredEmployeeList(employeeList);
                        setFilteredRevenueList(revenueList);
                        setCurrentPage(1);
                        console.log("Filters cleared:", clearedFilters);
                      }}
                    >
                      Clear all
                    </a>
                  </div>
                </div>
                <div className="card_box color-555">
                  <div className="search_criteria">
                    <div className="accordion" id="filterAccordion">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingCompanyName">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseCompanyName"
                            aria-expanded="false"
                            aria-controls="collapseCompanyName"
                          >
                            <i className="bi bi-building"></i> Company Name
                          </button>
                        </h2>
                        <div
                          id="collapseCompanyName"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingCompanyName"
                          data-bs-parent="#filterAccordion"
                        >
                          <div className="accordion-body">
                            {loading && !companyNameList.length ? (
                              <p>Loading company names...</p>
                            ) : error && !companyNameList.length ? (
                              <p>{error}</p>
                            ) : (
                              <div style={{ display: "flex", gap: "10px" }}>
                                <div className="dropdown" ref={companyDropdownRef} style={{ position: "relative", width: "100%" }}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Company"
                                    value={companySearchTerm}
                                    onChange={handleCompanySearch}
                                    onFocus={() => setIsCompanyDropdownOpen(true)}
                                  />
                                  {isCompanyDropdownOpen && (
                                    <ul
                                      className="dropdown-menu show"
                                      style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {filteredCompanyNames.length > 0 ? (
                                        filteredCompanyNames.map((company) => (
                                          <li
                                            key={company.company_id}
                                            className="dropdown-item"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleCompanySelect(company.company_name)}
                                          >
                                            {company.company_name}
                                          </li>
                                        ))
                                      ) : (
                                        <li className="dropdown-item">No companies found</li>
                                      )}
                                    </ul>
                                  )}
                                </div>
                                {filters.companyName && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setFilters((prev) => ({
                                        ...prev,
                                        companyName: "",
                                      }));
                                      setCompanySearchTerm("");
                                      setFilteredCompanyNames(companyNameList);
                                      setCurrentPage(1);
                                    }}
                                  >
                                    Clear
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingEmployees">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseEmployees"
                            aria-expanded="false"
                            aria-controls="collapseEmployees"
                          >
                            <i className="bi bi-people"></i> Employees
                          </button>
                        </h2>
                        <div
                          id="collapseEmployees"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingEmployees"
                          data-bs-parent="#filterAccordion"
                        >
                          <div className="accordion-body">
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div className="dropdown" ref={employeeDropdownRef} style={{ position: "relative", width: "100%" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search Employees"
                                  value={employeeSearchTerm}
                                  onChange={handleEmployeeSearch}
                                  onFocus={() => setIsEmployeeDropdownOpen(true)}
                                />
                                {isEmployeeDropdownOpen && (
                                  <ul
                                    className="dropdown-menu show"
                                    style={{
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {filteredEmployeeList.length > 0 ? (
                                      filteredEmployeeList.map((employee, index) => (
                                        <li
                                          key={index}
                                          className="dropdown-item"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleEmployeeSelect(employee)}
                                        >
                                          {employee}
                                        </li>
                                      ))
                                    ) : (
                                      <li className="dropdown-item">No employee ranges found</li>
                                    )}
                                  </ul>
                                )}
                              </div>
                              {filters.employees && (
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setFilters((prev) => ({
                                      ...prev,
                                      employees: "",
                                    }));
                                    setEmployeeSearchTerm("");
                                    setFilteredEmployeeList(employeeList);
                                    setCurrentPage(1);
                                  }}
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingRevenue">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseRevenue"
                            aria-expanded="false"
                            aria-controls="collapseRevenue"
                          >
                            <i className="bi bi-currency-dollar"></i> Revenue
                          </button>
                        </h2>
                        <div
                          id="collapseRevenue"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingRevenue"
                          data-bs-parent="#filterAccordion"
                        >
                          <div className="accordion-body">
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div className="dropdown" ref={revenueDropdownRef} style={{ position: "relative", width: "100%" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search Revenue"
                                  value={revenueSearchTerm}
                                  onChange={handleRevenueSearch}
                                  onFocus={() => setIsRevenueDropdownOpen(true)}
                                />
                                {isRevenueDropdownOpen && (
                                  <ul
                                    className="dropdown-menu show"
                                    style={{
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {filteredRevenueList.length > 0 ? (
                                      filteredRevenueList.map((revenue, index) => (
                                        <li
                                          key={index}
                                          className="dropdown-item"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleRevenueSelect(revenue)}
                                        >
                                          {revenue}
                                        </li>
                                      ))
                                    ) : (
                                      <li className="dropdown-item">No revenue ranges found</li>
                                    )}
                                  </ul>
                                )}
                              </div>
                              {filters.revenue && (
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setFilters((prev) => ({
                                      ...prev,
                                      revenue: "",
                                    }));
                                    setRevenueSearchTerm("");
                                    setFilteredRevenueList(revenueList);
                                    setCurrentPage(1);
                                  }}
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingIndustry">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseIndustry"
                            aria-expanded="false"
                            aria-controls="collapseIndustry"
                          >
                            <i className="bi bi-briefcase"></i> Industries
                          </button>
                        </h2>
                        <div
                          id="collapseIndustry"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingIndustry"
                          data-bs-parent="#filterAccordion"
                        >
                          <div className="accordion-body">
                            {loading && !industryList.length ? (
                              <p>Loading industries...</p>
                            ) : error && !industryList.length ? (
                              <p>{error}</p>
                            ) : (
                              <div style={{ display: "flex", gap: "10px" }}>
                                <select
                                  className="form-control"
                                  name="industry"
                                  value={filters.industry}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Industry</option>
                                  {industryList.map((industry, index) => (
                                    <option key={index} value={industry}>
                                      {industry}
                                    </option>
                                  ))}
                                </select>
                                {filters.industry && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() =>
                                      handleInputChange({
                                        target: { name: "industry", value: "" },
                                      })
                                    }
                                  >
                                    Clear
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {[
                        {
                          id: "job_title",
                          icon: "bi-person-badge",
                          title: "Job Title",
                          name: "job_title",
                          placeholder: "Enter job title",
                        },
                        {
                          id: "Location",
                          icon: "bi-geo-alt",
                          title: "Location",
                          name: "location",
                          placeholder: "Enter location",
                        },
                      ].map((filter, idx) => (
                        <div className="accordion-item" key={idx}>
                          <h2
                            className="accordion-header"
                            id={`heading${filter.id}`}
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${filter.id}`}
                              aria-expanded="false"
                              aria-controls={`collapse${filter.id}`}
                            >
                              <i className={`bi ${filter.icon}`}></i>
                              {filter.title}
                            </button>
                          </h2>
                          <div
                            id={`collapse${filter.id}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${filter.id}`}
                            data-bs-parent="#filterAccordion"
                          >
                            <div className="accordion-body">
                              <div style={{ display: "flex", gap: "10px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={filter.name}
                                  placeholder={filter.placeholder}
                                  value={filters[filter.name]}
                                  onChange={handleInputChange}
                                />
                                {filters[filter.name] && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() =>
                                      handleInputChange({
                                        target: { name: filter.name, value: "" },
                                      })
                                    }
                                  >
                                    Clear
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </aside>
            </div>

            <div className="col-lg-8">
              <div className="inner_wrapper card_box py-5">
                <ul className="nav nav-tabs fw-600 border-0">
                  <li className="nav-item">
                    <a
                      className={`nav-link px-5 ${activeTab === "Company" ? "active" : ""}`}
                      data-bs-toggle="tab"
                      href="#Company"
                      onClick={() => {
                        setActiveTab("Company");
                        setCurrentPage(1);
                      }}
                    >
                      Company
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link px-5 ${activeTab === "People" ? "active" : ""}`}
                      data-bs-toggle="tab"
                      href="#People"
                      onClick={() => {
                        setActiveTab("People");
                        setCurrentPage(1);
                      }}
                    >
                      People
                    </a>
                  </li>
                </ul>

                <div className="tab-content pt-3">
                  {error && (
                    <div className="alert alert-danger text-center" role="alert">
                      {error}
                    </div>
                  )}
                  <div
                    className={`tab-pane fade ${activeTab === "Company" ? "show active" : ""}`}
                    id="Company"
                  >
                    <section className="table_section table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col">Company Name</th>
                            <th scope="col">Founded</th>
                            <th scope="col">City/State</th>
                            <th scope="col">Primary Industry</th>
                            <th scope="col">Employee</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="5" className="text-center">

                                <div className="dataloading ft-16 fw-600 text-center">
                                  <i class="fa fa-spinner fa-spin loadingicon"></i>
                                  {/* Loading... */}
                                  </div>
                                
                              </td>
                            </tr>
                          ) : companies.length > 0 ? (
                            companies.map((company, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="profile-info">
                                    <div className="logo-name-row">
                                      <img
                                        src={company.company_img || dummyimage}
                                        className="rounded-circle"
                                        alt={company.company_name}
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          objectFit: "cover",
                                        }}
                                        onError={(e) => (e.target.src = dummyimage)}
                                      />
                                      <div>
                                        <a
                                          className="cname"
                                          href={`/CompanyProfile/${company.company_id}`}
                                          style={{
                                            color: "inherit",
                                            textDecoration: "none",
                                            whiteSpace: "nowrap",
                                            display: "block",
                                          }}
                                          onMouseOver={(e) =>
                                            (e.target.style.color = "red")
                                          }
                                          onMouseOut={(e) =>
                                            (e.target.style.color = "inherit")
                                          }
                                        >
                                          {company.company_name !== "NA"
                                            ? company.company_name
                                            : "Unknown Company"}
                                        </a>
                                        <span style={{ display: "block" }}>
                                          <a
                                            href={
                                              company.company_url.startsWith("http")
                                                ? company.company_url
                                                : `https://${company.company_url}`
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="company-url"
                                          >
                                            {company.company_url !== "NA"
                                              ? company.company_url
                                              : "No website available"}
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                </td>
                                <td>{company.founded || "N/A"}</td>
                                <td>{company.city || "N/A"}</td>
                                <td>{company.primary_industry || "N/A"}</td>
                                <td>{company.employees || "N/A"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                {filters.companyName
                                  ? `No company found for "${filters.companyName}"`
                                  : "No companies found"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </section>
                    {!filters.companyName && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    )}
                  </div>

                  <div
                    className={`tab-pane fade ${activeTab === "People" ? "show active" : ""}`}
                    id="People"
                  >
                    <section className="table_section table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="3" className="text-center">
                                <div className="dataloading ft-16 fw-600 text-center">
                                  <i class="fa fa-spinner fa-spin loadingicon"></i>
                                  {/* Loading... */}
                                  </div>
                              </td>
                            </tr>
                          ) : people.length > 0 ? (
                            people.map((person, index) => (
                              <tr key={index}>
                                <td className="profile-info">
                                  <div className="logo-name-row">
                                    <img
                                      src={userimg}
                                      className="rounded-circle"
                                      alt={`${person.first_name} ${person.last_name}`}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        objectFit: "cover",
                                      }}
                                      onError={(e) => (e.target.src = userimg)}
                                    />
                                    <div>
                                      <a
                                        className="cname"
                                        href={`/PeopleProfile/${person.member_id}`}
                                        style={{
                                          color: "inherit",
                                          textDecoration: "none",
                                          whiteSpace: "nowrap",
                                          display: "block",
                                        }}
                                        onMouseOver={(e) =>
                                          (e.target.style.color = "red")
                                        }
                                        onMouseOut={(e) =>
                                          (e.target.style.color = "inherit")
                                        }
                                      >
                                        {person.first_name && person.last_name
                                          ? `${person.first_name} ${person.last_name}`
                                          : "Unknown Person"}
                                      </a>
                                      <span style={{ display: "block" }}>
                                        {person.job_title || "No job title available"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{person.personal_email || "N/A"}</td>
                                <td>{person.state || "N/A"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No people found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </section>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}